/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityArea } from './';
import {
    ActivityAreaFromJSON,
    ActivityAreaFromJSONTyped,
    ActivityAreaToJSON,
} from './';
import type { CompanySizeResource } from './';
import {
    CompanySizeResourceFromJSON,
    CompanySizeResourceFromJSONTyped,
    CompanySizeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientCompanySettingsProfileUpdateRequest
 */
export interface ClientCompanySettingsProfileUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientCompanySettingsProfileUpdateRequest
     */
    name?: string;
    /**
     * 
     * @type {CompanySizeResource}
     * @memberof ClientCompanySettingsProfileUpdateRequest
     */
    size?: CompanySizeResource;
    /**
     * 
     * @type {ActivityArea}
     * @memberof ClientCompanySettingsProfileUpdateRequest
     */
    activityArea?: ActivityArea;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanySettingsProfileUpdateRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the ClientCompanySettingsProfileUpdateRequest interface.
 */
export function instanceOfClientCompanySettingsProfileUpdateRequest(value: object): value is ClientCompanySettingsProfileUpdateRequest {
    return true;
}

export function ClientCompanySettingsProfileUpdateRequestFromJSON(json: any): ClientCompanySettingsProfileUpdateRequest {
    return ClientCompanySettingsProfileUpdateRequestFromJSONTyped(json, false);
}

export function ClientCompanySettingsProfileUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanySettingsProfileUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'size': json['size'] == null ? undefined : CompanySizeResourceFromJSON(json['size']),
        'activityArea': json['activityArea'] == null ? undefined : ActivityAreaFromJSON(json['activityArea']),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ClientCompanySettingsProfileUpdateRequestToJSON(value?: ClientCompanySettingsProfileUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'size': CompanySizeResourceToJSON(value['size']),
        'activityArea': ActivityAreaToJSON(value['activityArea']),
        'description': value['description'],
    };
}

